import { QRCodeSVG } from 'qrcode.react';
import { client } from '../../config';
import { meest } from '../../styles/meest';
import { polonez } from '../../styles/polonez';

export interface Props {
  value: string;
  size?: number | 'fill';
  useBrandColor?: boolean;
  onClick?: () => void;
}

const QrConfig = {
  meest: {
    color: meest.colors.namedColors.primary,
  },
  polonez: {
    color: polonez.colors.namedColors.primary,
  },
};

const QrCode = ({ value, size, useBrandColor, onClick }: Props) => {
  const color = useBrandColor ? QrConfig[client].color : 'black';

  const sizeProps =
    size === 'fill' ? { style: { width: '100%', height: '100%' } } : { size };

  return (
    <QRCodeSVG
      value={value}
      {...sizeProps}
      bgColor='#fff'
      fgColor={color}
      onClick={() => onClick && onClick()}
    />
  );
};

export default QrCode;
